import React from 'react'
import { connect } from 'react-redux'
import Row from 'muicss/lib/react/row'
import { List, ListItem } from 'material-ui/List'
import Subheader from 'material-ui/Subheader'
import Divider from 'material-ui/Divider'
import Check from 'material-ui/svg-icons/navigation/check'
import Close from 'material-ui/svg-icons/navigation/close'
import Time from 'material-ui/svg-icons/device/access-time'
import CommunicationChatBubble from 'material-ui/svg-icons/communication/chat-bubble'
import FontAwesome from 'react-fontawesome'
import { reviewMission } from '../../../../actions'

const SHOWED_ELEMENTS = 10

const styles = {
  list: {
    overflow: 'scroll',
    maxHeight: (57 * SHOWED_ELEMENTS),
  },
}

class MissionHistory extends React.Component {

  generalHistory = (e, Icon, color, primaryText, nestedItems = []) => (
    <div>
      <ListItem
        leftIcon={<Icon color={color} />}
        primaryText={primaryText}
        secondaryText={
          new Date(e.created_at.substr(0, 19)).toLocaleString()
        }
        nestedItems={nestedItems}
        onClick={() => this.props.reviewMission(this.props.mission, e)}
      />
      <Divider />
    </div>
  )

  succeesHistory = e => (
    this.generalHistory(e, Check, 'green', '¡Tus respuestas fueron aprobadas!')
  )

  waitingHistory = e => (
    this.generalHistory(e, Time, 'yellow', 'En espera de revisión...')
  )

  wrongHistory = e => (
    this.generalHistory(e, Close, 'red', 'Vuelve a intentarlo', [
      <ListItem
        value={2}
        primaryText={e.comment}
        leftIcon={<CommunicationChatBubble />}
      />,
    ])
  )

  historyElement = e => ({
    6: this.wrongHistory(e),
    2: this.waitingHistory(e),
    3: this.succeesHistory(e),
  }[e.state])

  render() {
    return (
      <Row>
        <List>
          <Subheader>
            <FontAwesome
              name="arrow-left" style={{ margin: '10px', cursor: 'pointer' }}
              onClick={this.props.back}
            />
            Historial de Respuestas
          </Subheader>
          <Divider />
          <div style={styles.list} >
            { this.props.history.map(e =>
              this.historyElement(e),
            )}
          </div>
        </List>
      </Row>
    )
  }
}

MissionHistory.propTypes = {
  history: React.PropTypes.number,
  reviewMission: React.PropTypes.func,
}

const mapStateToProps = state => ({
  history: state.missions.selectedMission.history,
  mission: state.missions.selectedMission,
})

const mapDispatchToProps = dispatch => ({
  reviewMission: (mission, answer) => dispatch(reviewMission(mission, answer)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MissionHistory)



// WEBPACK FOOTER //
// ./src/components/CampaignShow/PreMissionShow/MissionHistory/index.jsx